export default __webpack_public_path__ + "static/media/Archdeacon's Leggings of the Eighteen Pits.ee4bd3a7.jpg";